// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"85":"c1450054","353":"696b3bcb","648":"ea153939","757":"c14691ee"}[chunkId] + ".css";
};